export enum ConfigManagerProperties {
  buildVersion = 'buildVersion',
  production = 'production',
  apiUrl = 'apiUrl',
  appName = 'appName',
  apiVersion = 'apiVersion',
  region = 'region',
  loggedInUserRoot = 'loggedInUserRoot',
  invoiceAppUrl = 'invoiceAppUrl',
}
